import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  format() {
    const digits = this.element.value.replace(/\D/g, "").slice(0, 8)
    this.element.value = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }
}
